import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { withList, withoutList } from "../data/content";
import { SectionTitle } from "./SectionTitle";
import { CtaButton } from "./CtaButton";
export function Closing() {
  return <section className="bg-forest px-4 py-16 sm:px-6 sm:py-24" data-id="element-27" data-mp="3f8uu0xduug5d">
      <SectionTitle title={<>Arrêtez d'improviser. <span className="text-gold" data-id="element-29" data-mp="3j8v6wdlb2jab">Enseignez avec un système.</span></>} subtitle="2 livres et 5 bonus prêts à l'emploi pour arriver à chaque cours avec un plan clair." data-id="element-28" data-mp="3ja6c8huefz3j" />
      <div className="mx-auto mt-12 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-30" data-mp="3abul8epmezak">
        <div className="rounded-2xl border border-moss bg-deep p-6" data-id="element-31" data-mp="2wbjvjf01rqqz">
          <h3 className="font-display text-2xl font-bold uppercase text-white/60" data-id="element-32" data-mp="30btz6l0da52o">Sans Le Maître de la Guitare™</h3>
          <ul className="mt-5 space-y-4" data-id="element-33" data-mp="uivosvo72l6g">
            {withoutList.map(b => <li key={b} className="flex gap-3 text-white/70" data-id="element-34" data-mp="ykgxs5xlyfbd">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden data-id="element-35" data-mp="yimmzkg1w3l0" />
                {b}
              </li>)}
          </ul>
        </div>
        <div className="rounded-2xl border-2 border-gold bg-deep p-6" data-id="element-36" data-mp="3m1ukloqawtzn">
          <h3 className="font-display text-2xl font-bold uppercase text-gold" data-id="element-37" data-mp="4mxncck9zf79">Avec Le Maître de la Guitare™</h3>
          <ul className="mt-5 space-y-4" data-id="element-38" data-mp="3vsfjzedsu2jm">
            {withList.map(a => <li key={a} className="flex gap-3 text-white" data-id="element-39" data-mp="382uwci6pah40">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden data-id="element-40" data-mp="383d1637fi3nj" />
                {a}
              </li>)}
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-xl text-center" data-id="element-41" data-mp="3i22ah7l9efs6">
        <p className="font-display text-3xl font-bold uppercase text-white sm:text-4xl" data-id="element-42" data-mp="3d2haquy9m3ee">
          Le pack complet : <span className="text-gold" data-id="element-43" data-mp="xajz483npq57">29 €</span>
        </p>
        <p className="mt-1 text-sm text-white/70" data-id="element-44" data-mp="xd6728ugm7ny">2 livres + 5 bonus · Paiement unique · Garantie 10 jours</p>
        <CtaButton label="Je veux Le Maître de la Guitare™" action="checkout" className="mt-7 w-full sm:w-auto" data-id="element-45" data-mp="sebieq9t9ovx" />
      </div>
    </section>;
}